// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mz-0";
export var assigneeDetails = "_mz-1";
export var assigneeInfo = "_mz-2";
export var dropdownContainer = "_mz-4";
export var dropdownImage = "_mz-5";
export var editAssigneeInfo = "_mz-3";
export var editAssigneeModalContainer = "_mz-6";
export var hidden = "_mz-8";
export var input = "_mz-7";